'use client';

import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import { Text } from '@/shared/ui';
import { useModal } from '@/features/Modals/hooks';
/*In case of custom logic made override for SupplyInput here*/
import { SupplyInput } from '@/widgets/Modals';
import { useMaxBalance } from '@/features/Modals/ui/Pools/Supply/hooks/useMaxBalance';

type SupplyInputProps = {
    value: string;
    name: string;
    setValue: (value: string | null) => void;
    userBalance: string;
    tokenSymbol: string;
    poolBalance: string;
    disabled: boolean;
    decimals: number;
    totalDeposited?: string;
    totalDepositThreshold?: string;
};

type SupplyAmountFieldProps = {
    name: string;
};

export const SupplyAmountField = ({ name }: SupplyAmountFieldProps) => {
    const { control } = useFormContext();
    const { modalProps } = useModal();

    const {
        balance: userBalance,
        tokenSymbol,
        currentApy,
        totalDeposited,
        totalDepositThreshold,
        decimals,
        poolBalance,
    } = modalProps || {};

    const maxBalance = useMaxBalance();

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <SupplyInput<SupplyInputProps>
                    {...field}
                    setValue={(value) => field.onChange(value)}
                    userBalance={userBalance}
                    tokenSymbol={tokenSymbol}
                    poolBalance={poolBalance}
                    decimals={decimals}
                    totalDepositThreshold={totalDepositThreshold}
                    totalDeposited={totalDeposited}
                    disabled={Number(userBalance) === 0}
                    maxBalance={maxBalance}
                    label={
                        <>
                            <Text
                                type={Text.types.Paragraph}
                                className='text-content-tertiary font-medium'
                                name='supply-apy-label'
                            >
                                Supply APY:
                            </Text>
                            <Text
                                type={Text.types.Paragraph}
                                fontWeight={Text.weights.SemiBold}
                                name='supply-apy-value'
                            >
                                {currentApy}%
                            </Text>
                        </>
                    }
                />
            )}
        />
    );
};
